module.exports = {
  domain: {
    Base_URL: '',
    Base_M1_URL: '',
    Base_M2_URL: '',
    Preview_Domain: `https://showfile.cesa.cn/preview/onlinePreview`
  }
}
